import { jsx as d } from "react/jsx-runtime";
import { createElement as p } from "react";
import o from "classnames";
import '../../assets/Container.css';const a = "_container_nnssw_9", f = "_content_nnssw_46", r = {
  container: a,
  content: f
}, x = ({ as: e, children: i, classnames: t, inset: n, color: c = "light", ..._ }) => p(
  e,
  {
    ..._,
    className: o(r.container, t == null ? void 0 : t.container),
    "data-inset": n,
    "data-color": c
  },
  /* @__PURE__ */ d("div", { className: o(r.content, t == null ? void 0 : t.content), "data-parent-inset": n, children: i })
);
export {
  x as default
};
